import { render, staticRenderFns } from "./municipios.vue?vue&type=template&id=8789b0ba&"
import script from "./municipios.vue?vue&type=script&lang=ts&"
export * from "./municipios.vue?vue&type=script&lang=ts&"
import style0 from "./municipios.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports